import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/global-set'

const NAME_PREFIX = 'GLOBAL_SET';

const DEFAULT_SIZE = 10

const RECEIVE_LIST = `${NAME_PREFIX}_RECEIVE_LIST`

const RECEIVE_DETAIL = `${NAME_PREFIX}_RECEIVE_DETAIL`

export const CHANGE_PAGE = `${NAME_PREFIX}_CHANGE_PAGE`

export const CHANGE_QUERY = `${NAME_PREFIX}_CHANGE_QUERY`

export const SHOW_MODAL = `${NAME_PREFIX}_SHOW_MODAL`

export const HIDE_MODAL = `${NAME_PREFIX}_HIDE_MODAL`

export const GET_ALL_SETTING = `${NAME_PREFIX}_GET_ALL_SETTING`

export const CHANGE_FILTER_LIST = `${NAME_PREFIX}_CHANGE_FILTER_LIST`

//action
function getData(params,dispatch,form) {
    return http.post(`${API_PREFIX}/filter?${qs.stringify(params)}`,form)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}
export function getFormData(query, filterList) {
    const form = {
        "logic": "and",
        "filters": []
    }
    const keys = Object.keys(query);
    keys.forEach(key=>{
        if (query[key]) {
            form.filters.push({
                "field": key,
                "operator": filterList.find(item=>item.value === key).operator,
                "value": query[key]
            })
        }
    })
    return form;
}

export function getList() {
    return (dispatch,getState) => {
        const {global: {page, query, filterList}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        const form = getFormData(query, filterList);
        getData(data,dispatch,form)
    };
}

export function getAllSetting() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/map`)
            .then(data => {
                dispatch({
                    type: GET_ALL_SETTING,
                    data: data.data
                })
                return data.data
            })
    }
}

export function add(formData) {
    return (dispatch,getState) => {
        return http.post(`${API_PREFIX}/add`,formData)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function remove(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
                dispatch(getAllSetting())
            })
    }
}
export function update(formData) {
    return (dispatch,getState) => {
        console.info(formData);
        return http.post(`${API_PREFIX}/update/${formData.id}`,formData)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
                dispatch(getAllSetting())
            })
    }
}

export function modify(name, value) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/modify/${name}?value=${value}`)
            .then(() => {
                dispatch(getAllSetting())
            })
    }
}

export function showUpdateModal(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then((data) => {
                dispatch({type: RECEIVE_DETAIL, detail: data.data})
                dispatch({type: SHOW_MODAL, key: 'update', id})
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        update: false,
        id: null
    },
    detail: {},
    allSetting: {},
    filterList: [
        {name: '名称', componentType: 'Text', isShow: false, value: 'name', operator: 'contains'},
        {name: '数值', componentType: 'Text', isShow: false, value: 'value', operator: 'contains'}
    ],
    query: {}
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [GET_ALL_SETTING]: (state,{data}) => {
        return {...state,allSetting: data}
    },
    [CHANGE_FILTER_LIST]: (state,{value}) => {
        return {...state,filterList: value}
    },
    [CHANGE_QUERY]: (state,{key,value}) => {
        return {...state,query: {...state.query,[key]: value}, page: {index: 0, size: DEFAULT_SIZE}}
    },
    [RECEIVE_DETAIL]: (state, {detail}) => {
        return {...state, detail}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/global/reducers/list.js